import {TranslocoService} from '@ngneat/transloco';

export class SynopticsPropertiesErrors {

  private synopticsPropertiesErrors: { [key: string]: string };

  constructor(private readonly i18n: TranslocoService) {
    this.i18n.selectTranslation().subscribe(() => {
      this.synopticsPropertiesErrors = {
        svg: this.i18n.translate('info.importSynopticFiles.fieldsTitle.svg'),
        id: this.i18n.translate('info.importSynopticFiles.fieldsTitle.id'),
        operation: this.i18n.translate('info.importSynopticFiles.fieldsTitle.operation'),
        configuration: this.i18n.translate('info.importSynopticFiles.fieldsTitle.configuration')
      };
    });
  }

  public getTranslation(property: any): string | null {
    return this.synopticsPropertiesErrors.hasOwnProperty(property) ? this.synopticsPropertiesErrors[property] : null;
  }
}

